<!-- 
Layout used once a user is signed-in for almost all pages.
-->
<template>
  <div>
    <navigation-drawer v-model="drawer" />
    <toolbar :drawer.sync="drawer" :skip-to="this.$refs.skipTo" />
    <v-content>
      <div class="scroll-container">
        <v-container fluid>
          <div ref="skipTo">
            <slot/>
          </div>
        </v-container>
      </div>
    </v-content>
    <notification-snackbar />
  </div>
</template>

<script>
import NavigationDrawer from "@/components/system/NavigationDrawer.vue";
import Toolbar from "@/components/system/Toolbar.vue";
import NotificationSnackbar from "@/components/system/NotificationSnackbar.vue";

export default {
  components: { NavigationDrawer, Toolbar, NotificationSnackbar },
  data: () => ({
    drawer: null,
    admin: true
  }),
  computed: {
    isSignedIn() {
      return this.$store.getters.isSignedIn;
    }
  }
};
</script>
